var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.disableInteraction
        ? [
            _c(
              "div",
              { style: _vm.activatorStyle },
              [
                _c("icon-svg", { attrs: { name: "crown", size: _vm.iconSize } })
              ],
              1
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "d-flex align-center" },
              [
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "max-width": "300",
                      "offset-y": "",
                      "nudge-right": _vm.nudgeRight,
                      "nudge-top": _vm.nudgeTop,
                      "open-on-hover": "",
                      "close-delay": _vm.TIME_TO_CLOSE,
                      "close-on-content-click": false,
                      "content-class": _vm.contentClass
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "div",
                              _vm._g(
                                _vm._b(
                                  { style: _vm.activatorStyle },
                                  "div",
                                  attrs,
                                  false
                                ),
                                _vm.mergeMenuListeners(on)
                              ),
                              [
                                _c("icon-svg", {
                                  attrs: { name: "crown", size: _vm.iconSize }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.menuActive,
                      callback: function($$v) {
                        _vm.menuActive = $$v
                      },
                      expression: "menuActive"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "pa-4 no-module-access-container" },
                      [
                        _c(
                          "p",
                          { staticClass: "ma-0 no-module-access-title" },
                          [_vm._v(_vm._s(_vm.title))]
                        ),
                        _c("v-divider", { staticClass: "mt-2 mb-4" }),
                        !_vm.disableModuleImage
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "no-module-access-image-container rounded-sm"
                              },
                              [
                                _c("v-img", {
                                  style: _vm.imageStyle,
                                  attrs: {
                                    width: "100%",
                                    cover: "",
                                    src: _vm.imageSrc
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "placeholder",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-center"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "mt-12" },
                                                  [
                                                    _c("v-progress-circular", {
                                                      attrs: {
                                                        indeterminate: "",
                                                        color: "primary"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    1511126873
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "p",
                          {
                            staticClass: "ma-0 my-4 no-module-access-subtitle"
                          },
                          [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
                        ),
                        _c(
                          "BaseButton",
                          {
                            attrs: { minWidth: "100%", primary: "" },
                            on: { click: _vm.openWhatsapp }
                          },
                          [_vm._v(" Saiba mais ")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }